import { FrameworkControlTaskTableRow } from "./FrameworkControlOverview.types";
import { applyClientFilters } from "@common/components/filterBar/filterOperatorMatching.ts";
import { FilterOperatorUi } from "@common/api/filterTypes.ts";

// Deadlines filter by calendar month, so both the option ids and the row candidate go through monthKey.
// The month is the unit the option list offers, while the backend hands out one deadline per day.
export function monthKey(date: Date | string): string {
    const value = new Date(date);
    return `${value.getFullYear()}-${(value.getMonth() + 1).toString().padStart(2, "0")}`;
}

export function filterFrameworkControlTaskRows(
    rows: Array<FrameworkControlTaskTableRow>,
    selectFilters: Record<string, Array<string>>,
    filterOperators: Record<string, FilterOperatorUi>
): Array<FrameworkControlTaskTableRow> {
    return applyClientFilters(
        rows,
        [
            { id: "deadline", candidate: (r) => monthKey(r.deadline) },
            // Responsible and assignees share one entry on purpose. applyClientFilters ANDs its entries, so
            // separate ones would demand the person be both; a single array candidate matches on overlap.
            {
                id: "responsibleOrAssignee",
                candidate: (r) => [r.responsible?.id, ...r.assignees.map((a) => a.id)].filter((x): x is string => x !== undefined),
            },
            { id: "status", candidate: (r) => r.status.toString() },
        ],
        selectFilters,
        {},
        filterOperators
    )!;
}
